import { css } from '@emotion/css';
import React from 'react';
import { ClassicLoading } from './ClassicLoading';

export const Loading: React.FC<{ color?: string; size?: number }> = ({ color, size }) => {
  return (
    <div
      className={css`
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      `}
    >
      <ClassicLoading color={color || '#00B7D2'} size={size} />
    </div>
  );
};
